export default {
  appTitle: 'Web de proveedores',
  title: 'Iniciar sesión',
  loginButton: 'Iniciar sesión',
  registerButton: 'Registrarme',
  consultRecordButton: 'Consultar registro',
  forgotPasswordButton: 'Reestablecer contraseña',
  signIn: {
    button: 'Crear cuenta',
    label: '¿Aún no tienes una cuenta?'
  },
  email: {
    inputLabel: 'Correo electrónico'
  },
  password: {
    inputLabel: 'Contraseña'
  },
  temporal: {
    title: 'Trámites temporales',
    description: 'Creación y consulta de estado de solicitudes temporales a GNP para proveedores sin convenio de pago directo:',
    newButton: 'Nuevo trámite',
    checkButton: 'Consultar estado'
  }
}
